module.exports = __webpack_public_path__ + "img/juan-ruvalcaba.jpg";